export default (ctx, inject) => {
  // lodash templating
  const brand = {"name":"JóSzaki","about":"A JóSzakiról","forTheBrand":"a JóSzakira","withTheBrand":"a JóSzakival","description":"Közösségi szakemberkereső","metaTitle":"JóSzaki - Közösségi szakemberkereső - Szakemberek, értékelések, referenciák","metaDescription":"Értékelt szakemberek 1 helyen.","schemaDescription":"Szakember kereső","slogan":"A közösség ajánlásával","webpage":"JóSzaki.hu","logo":{"part1":"JÓ","part2":"SZAKI"},"fromMate":"JóSzakis szakemberünktől!","since":"2010","themeColor":"#337ab7","features":["about-us","career-page","header-search","job-market","price-offer","price-offer-landing","price-offer-public-access","blog","questions","professionals","favourites","prices","inspiration","salary-checker","registration","customer-registration","google-login","dynamic-nav-links","bank-statement-import"],"supportedLocales":["hu-HU"],"company":{"name":"JóSzaki Kft.","address":"1068 Budapest, Király utca 82. 4. em. 3. ajtó","registrationAuthority":"Fővárosi Törvényszék Cégbírósága","registrationNumber":"01-09-328629","taxNumber":"26495248-2-42","hosting":"Google LLC (1600 Amphitheatre Parkway Mountain View, CA 94043, USA)"}};

  const brandName =  "joszaki";
  const isSuperprofikCz = brandName === "superprofik-cz";
  const isBerufExperten = brandName === "berufexperten-de";
  const isJoszaki = brandName === "joszaki";
  const isPriceOffer = brandName === "price-offer-creator";

  inject('brand', brand);
  inject('branding', {
    name: brandName,
    isSuperprofikCz,
    isBerufExperten,
    isJoszaki,
    isPriceOffer,
    supportedLocales: brand?.supportedLocales || [],
    /**
     * Check if a feature is enabled for the current brand
     * @param {string} feature - Feature name (e.g., 'blog', 'job-market')
     * @returns {boolean} - True if feature is enabled
     */
    hasFeature(feature) {
      const brandFeatures = brand?.features || [];
      return brandFeatures.includes(feature);
    }
  })
};
